import styled from 'styled-components';

export const ContainerLoja = styled.div`
  width: 100%;
  padding: 0 1.5rem;
  max-width: 900px;
`;

export const ContentLoja = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  padding: 20px 0;
  width: 100%;
`;

export const SettingsCard = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  h3 {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
  }
  svg {
    color: #3b82f6;
    font-size: 1.2rem;
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }
`;

export const QrCodeRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;

  label {
    font-size: 0.875rem;
    font-weight: 500;
    color: #475569;
  }

  select,
  input[type='number'] {
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 0.875rem;
    color: #1e293b;
    background: #f8fafc;
    min-width: 140px;
    outline: none;

    &:focus {
      border-color: #3b82f6;
    }
  }
`;

export const QrCodeActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
`;

export const ApiKeyBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  margin-top: 12px;

  code {
    font-family: monospace;
    font-size: 0.85rem;
    color: #1e293b;
    word-break: break-all;
  }
`;
